import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { Proyecto, ProyectoPagingRes } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch , handleAxiosError} from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchProyectos = ({
  page = 1,
  page_size = 10,
  nombre = '',
}: GetProyectosParams) => {
  return useQuery({
    queryKey: ['proyectos', page, nombre, page_size],
    queryFn: async () => {
      return getProyectos({ page, nombre, page_size});
    },
  });
};

export const useGetProyecto = (id: string) => {
  return useQuery({
    queryKey: ['proyectos', id],
    queryFn: async () => {
      return getProyecto(id);
    },
  });
};

export const useCreateProyectos = (navigate: NavigateFunction, returnUrl: string,
  enableNavigation = true
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProyectos,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['proyectos'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

export const useUpdateProyectos = (navigate: NavigateFunction, returnUrl: string
,
noState?: boolean,
enableNavigation?: boolean

) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProyectos,
    onSuccess: () => {
      noState && queryClient.invalidateQueries({ queryKey: ['proyectos'] });
      enableNavigation && navigate(returnUrl, { replace: true });
    },onError: error => {
      handleAxiosError(error);
    },
  });
};

///* axios
export type GetProyectosParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
  codigo?: string;
  fecha_inicio?:string;
  fecha_final?:string;
  presupuesto?:number;
  descripcion?:string;
  descuento?:number;
  responsable?:string;
};

export type CreateProyectosParams = Omit<Proyecto, 'id_proyecto'>;
export type UpdateProyectosParams = {
  id: string;
  data: CreateProyectosParams;
};

export const getProyectos = async (params?: GetProyectosParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<ProyectoPagingRes>(
    `${urlBackend}api/v1/proyectos/?${queryParams}`,
    true
  );
};

export const getProyecto = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<Proyecto>(`${urlBackend}api/v1/proyectos/${id}/`, true);

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};

export const createProyectos = async (data: CreateProyectosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<Proyecto>(`${urlBackend}api/v1/proyectos/`, data, true);
  setAlert(true, res.message, res.status);
  return res;
};

export const updateProyectos = async ({ id, data }: UpdateProyectosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<Proyecto>(`${urlBackend}api/v1/proyectos/${id}/`, data, true);
  setAlert(true, res.message, res.status);
  return res;
};
